import React from "react"
import { LanguageProvider } from "./src/components/language-selector/language-selector"
export const wrapRootElement = ({ element }) => (
	<LanguageProvider>{ element }</LanguageProvider>
)